/* @flow */
import * as React from 'react';
import CanvasACI from 'admin/components/CanvasACI';
import ACISuccess from 'admin/components/ACISuccess';
import ACIContainer from 'admin/containers/ACIContainer';
import SchoologyACI from 'admin/components/SchoologyACI';
import OrganizationIntegrationPermissions from 'admin/components/OrganizationIntegrationPermissions';

type State = {
  success: boolean,
};

type Props = {
  params: {
    providerKey: string,
    organizationUUID: string,
  },
};

function NotFound() {
  return <div>error</div>;
}

class ACIPage extends React.Component<Props, State> {
  state: State = {
    success: false,
  };

  handleDone = () => {
    this.setState({ success: true });
  };

  getViewComponent = (key: string) => {
    // prettier-ignore
    switch (key) {
      case 'canvas':    return CanvasACI;
      case 'schoology': return SchoologyACI;
      default:          return NotFound;
    }
  };

  getName = (key: string) => {
    // prettier-ignore
    switch (key) {
      case 'canvas':    return 'Canvas';
      case 'schoology': return 'Schoology';
      default:          return 'not_found';
    }
  };

  getIconURL = (key: string) => {
    // prettier-ignore
    switch (key) {
      case 'canvas':    return require('assets/images/canvas.svg');
      case 'schoology': return require('assets/images/schoology.svg');
      default:          return NotFound;
    }
  };

  render() {
    if (this.state.success) {
      return (
        <ACISuccess
          name={this.getName(this.props.params.providerKey)}
          iconURL={this.getIconURL(this.props.params.providerKey)}
        />
      );
    }

    const C = this.getViewComponent(this.props.params.providerKey);

    return (
      <OrganizationIntegrationPermissions organizationUUID={this.props.params.organizationUUID}>
        {({ loading, canEdit }) => {
          if (loading || !canEdit) {
            return null;
          }

          return (
            <ACIContainer
              providerKey={this.props.params.providerKey}
              organizationUUID={this.props.params.organizationUUID}>
              {({ integration, upsert }) => {
                if (!integration) {
                  return null;
                }

                return (
                  <C
                    upsert={upsert}
                    onDone={this.handleDone}
                    integration={integration}
                    organizationUUID={this.props.params.organizationUUID}
                  />
                );
              }}
            </ACIContainer>
          );
        }}
      </OrganizationIntegrationPermissions>
    );
  }
}

export default ACIPage;
